import * as types from 'store/types'

const initialState = {
  isLoggedIn: false,
  user: {
    is_fcm_loading: false,
    fcm_token: null
  },
  token: null
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_MEMBERSHIP: {
      const { user } = state
      user.member_code = action.data.member_code
      user.membership = action.data
      return { ...state, user }
    }
    case types.SET_LOGGED_IN_USER:
      return {
        ...state,
        user: { ...action.data.user },
        isLoggedIn: true,
        token: action.data.token
      }

    case types.SET_USER_LOGOUT: {
      return { ...initialState }
    }
    case types.SET_FCM_LOADED: {
      return {
        ...state,
        user: {
          ...state.user,
          is_fcm_loaded: action.status
        }
      }
    }
    case types.SET_FCM_TOKEN: {
      return {
        ...state,
        user: {
          ...state.user,
          fcm_token: action.token
        }
      }
    }
    case types.UPDATE_USER: {
      return {
        ...state,
        user: { ...action.data }
      }
    }
    case types.UPDATE_NOTIFICATION_SETTINGS: {
      return {
        ...state,
        user: {
          ...state.user,
          notification_settings: { ...state.user.notification_settings, settings: { ...action.value } }
        }
      }
    }
    case types.UPDATE_EXTENSION_SETTINGS: {
      return {
        ...state,
        user: {
          ...state.user,
          settings: { ...state.user.settings, settings: { ...action.value } }
        }
      }
    }
    default:
      return state
  }
}
export default authReducer
